import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiActivity } from 'react-icons/fi';

const Footer = () => {
  return (
    <footer className="bg-slate-50 pt-16 pb-8 border-t border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-start gap-12 mb-12">
          <div className="max-w-xs">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded bg-brand-600 flex items-center justify-center text-white">
                <SafeIcon icon={FiActivity} className="w-5 h-5" />
              </div>
              <span className="font-bold text-xl tracking-tight text-slate-900 italic">Scorewidget</span>
            </div>
            <p className="text-slate-500 text-sm leading-relaxed">
              A toolkit for football fans to build amazing data-driven experiences.
            </p>
          </div>
          
          <div className="flex gap-16">
            <div>
              <h4 className="text-slate-900 font-bold text-sm mb-4 uppercase tracking-wider">Explore</h4>
              <ul className="space-y-2 text-sm text-slate-500 font-medium">
                <li><a href="#" className="hover:text-brand-600">Widget Builder</a></li>
                <li><a href="#" className="hover:text-brand-600">Live Demo</a></li>
                <li><a href="#" className="hover:text-brand-600">Documentation</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-slate-900 font-bold text-sm mb-4 uppercase tracking-wider">Support</h4>
              <ul className="space-y-2 text-sm text-slate-500 font-medium">
                <li><a href="#" className="hover:text-brand-600">Help Center</a></li>
                <li><a href="#" className="hover:text-brand-600">Community</a></li>
                <li><a href="#" className="hover:text-brand-600">Twitter</a></li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="pt-8 border-t border-slate-200 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-400 text-xs font-bold uppercase tracking-widest">
            &copy; {new Date().getFullYear()} Scorewidget. All goals tracked.
          </p>
          <div className="flex gap-6 text-xs font-bold text-slate-400 uppercase tracking-widest">
            <a href="#" className="hover:text-slate-600">Terms</a>
            <a href="#" className="hover:text-slate-600">Privacy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;